/*
 * Expanding contact
 * Old C&L
 */

$(document).ready(function () {
    var expanders = $('.expanding-contact');
    if (expanders.length > 0) {
        expanders.each(function (i) {
            var expander = expanders[i];

            $(expander).on('click', '.expanding-contact-btn', function (e) {
                e.preventDefault();
                $(this).toggleClass('show');
                $(this).next('.expanding-contact-wrapper').toggleClass('show');
            });
        })
    }
})